/**
 * Percent shown in workflow report / sidebar workflow mode.
 * Legacy company modules use task workflow scores; temp modules use checklist completionPercent.
 */
export const getWorkflowDisplayPercent = (stats) => {
	if (!stats) return 0;
	if (stats.workflowMaxScore > 0) return stats.workflowCompletionPercent ?? 0;
	return stats.completionPercent ?? 0;
};
